import { render, staticRenderFns } from "./profile-new-ux.vue?vue&type=template&id=01f420c4&"
import script from "./profile-new-ux.vue?vue&type=script&lang=js&"
export * from "./profile-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f420c4')) {
      api.createRecord('01f420c4', component.options)
    } else {
      api.reload('01f420c4', component.options)
    }
    module.hot.accept("./profile-new-ux.vue?vue&type=template&id=01f420c4&", function () {
      api.rerender('01f420c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/profile-new-ux.vue"
export default component.exports